// Demirbaş Takibi — web ekranları arasında paylaşılan sabitler ve küçük yardımcılar.
// (Enum eşlemeleri backend sözleşmesine göre; AssetsPage/AssetDetailPage'teki değerlerle uyumlu.)

// Demirbaş tipleri — mobil/backend enum eşlemesi.
export const ASSET_TYPE_META = {
  COOLER: 'Soğutucu',
  CABINET: 'Dolap',
  STAND: 'Stand',
  SHELF: 'Raf',
  DISPLAY: 'Vitrin',
};
export const ASSET_TYPE_OPTIONS = Object.entries(ASSET_TYPE_META).map(([value, label]) => ({ value, label }));

// Özellik (attribute) alan tipleri.
export const FIELD_TYPE_META = {
  TEXT: { label: 'Metin', tone: 'neutral' },
  NUMERIC: { label: 'Sayısal', tone: 'ok' },
  CHOICE: { label: 'Seçim Listesi', tone: 'wait' },
  DATE: { label: 'Tarih', tone: 'neutral' },
  BARCODE: { label: 'Barkod', tone: 'photo' },
  BOOL: { label: 'Evet/Hayır', tone: 'neutral' },
};
export const FIELD_TYPE_OPTIONS = Object.entries(FIELD_TYPE_META).map(([value, meta]) => ({ value, label: meta.label }));

// lifecycleStatus sayısaldır: 0 Taslak | 1 Aktif | 2 Pasif.
export const ASSET_LIFECYCLE_META = {
  0: { label: 'Taslak', tone: 'neutral' },
  1: { label: 'Aktif', tone: 'ok' },
  2: { label: 'Pasif', tone: 'bad' },
};
export const ASSET_LIFECYCLE_OPTIONS = [
  { value: '0', label: 'Taslak' },
  { value: '1', label: 'Aktif' },
  { value: '2', label: 'Pasif' },
];

// JSON dizi string'ini güvenli parse et (string[] döner).
export function parseJsonArray(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter((x) => x !== undefined && x !== null && x !== '');
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.filter((x) => x !== undefined && x !== null && x !== '');
    if (typeof parsed === 'string' && parsed) return [parsed];
    return [];
  } catch {
    return typeof raw === 'string' && raw ? [raw] : [];
  }
}

// String dizisini JSON dizi string'ine çevir (boş → null).
export function toJsonArrayString(arr) {
  const clean = (arr || []).map((x) => String(x).trim()).filter(Boolean);
  return clean.length ? JSON.stringify(clean) : null;
}
